import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
type Props = {
  className?: string;
  width?: number;
  height?: number;
  isOnTwoColumns?: boolean;
};
export default function CommunityCardLoader({
  className,
  width = 400,
  height = 400,
  isOnTwoColumns = false
}: Props) {
  return <Wrapper className={className} data-sentry-element="Wrapper" data-sentry-component="CommunityCardLoader" data-sentry-source-file="communityCardLoader.tsx">
      {[...Array(12)].map((_, i) => <StyleContentLoader aria-label="" backgroundColor="#f3f3f3" className={isOnTwoColumns ? 'base-card-wider' : 'base-card'} foregroundColor="#ecebeb" height={height} key={i} // eslint-disable-line react/no-array-index-key
    uniqueKey={String(i)} viewBox={`0 0 ${width} ${height}`} width={width}>
          <rect height={height} rx="3" ry="3" width={width} x="0" y="0" />
        </StyleContentLoader>)}
    </Wrapper>;
}
const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const StyleContentLoader = styled(ContentLoader)`
  height: 100%;
`;